export default "__VITE_ASSET__f992f193__"